module.exports = __webpack_public_path__ + "img/deviceCloud4.2bb20bfc.png";